import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const VCSDistributionStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
}) => {
    return <div>VCS Distribution Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
